import React from 'react'

const PreviewHero = () => {
    return (
        <div className="previewHeroArea item1" id="home">
            <div className="container">
                  <div className="slide-content">
                      <div className="slide-subtitle">
                          <h4>WERE GETTING MARRIED</h4>
                      </div>
                      <div className="slide-title">
                          <h2>Save Our Date</h2>
                      </div>
                      <div className="slide-text">
                          <p>25 December 2019</p>
                      </div>
                  </div>
              </div>
        </div>
    )
}
export default PreviewHero;